import { render, staticRenderFns } from "./AdminUserAddressesElement.vue?vue&type=template&id=5c2687b7&scoped=true"
import script from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUserAddressesElement.vue?vue&type=style&index=0&id=5c2687b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2687b7",
  null
  
)

export default component.exports